export const PRIMARY_COLOR = '#353535';
export const SECONDARY_COLOR = '#87CC2E';
